export function useCopyTable(tableId) {
    const tabela = document.getElementById(tableId);

    console.log('useCopyTable', tableId, tabela);
    if (!tabela) {
        alert('Tabela não encontrada!');
        return;
    }

    let texto = '';

    // Pega cabeçalho
    const linhasCabecalho = tabela.querySelectorAll('thead tr');
    linhasCabecalho.forEach(linha => {
        const colunas = linha.querySelectorAll('th, td');
        colunas.forEach((coluna, index) => {
            texto += coluna.innerText + (index < colunas.length - 1 ? '\t' : '');
        });
        texto += '\n';
    });

    // Pega corpo
    const linhasCorpo = tabela.querySelectorAll('tbody tr');
    linhasCorpo.forEach(linha => {
        const colunas = linha.querySelectorAll('th, td');
        colunas.forEach((coluna, index) => {
            texto += coluna.innerText + (index < colunas.length - 1 ? '\t' : '');
        });
        texto += '\n';
    });

    if (navigator.clipboard) {
        return navigator.clipboard.writeText(texto)
            .then(() => {
                // alert('Tabela copiada com sucesso!');
            })
            .catch(err => {
                console.error('Erro ao copiar tabela: ', err);
            });
    } else {
        return alert('Clipboard API não suportada neste navegador.');
    }


};
